/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    FormLabel,
    Grid,
    TextField,
    Typography
} from '@mui/material';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';

/*  Helpers */
import { Notify } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const saveAdminUser = async (adminEmail, tenantId, onSuccessFn, t) => {
    try {
        await axios.post(`/user`, {
            admin: true,
            email: adminEmail,
            firstName: adminEmail,
            lastName: '',
            tenantId,
            tenantUserId: adminEmail
        });

        Notify.s(t('GlobalAdmin.Tenant.Edit.AddAdmin.success'));
        if (onSuccessFn) {
            onSuccessFn();
        }
    } catch (e) {
        debug.e(e.toString());
        Notify.e(t('GlobalAdmin.Tenant.Edit.AddAdmin.error'));
    }
};

export const AddAdminUser = ({ tenant, onSuccessFn }) => {
    const { t } = useTranslation();

    const [adminEmail, setAdminEmail] = useState(tenant?.adminUser?.email);
    const [expanded, setExpanded] = useState(true);
    return (
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            slotProps={{ transition: { unmountOnExit: true } }}
        >
            <AccordionSummary
                expandIcon={
                    <IconWithVariant
                        data-testid="expandAccordionIconAdminUser"
                        variant="primary"
                        src="ChevronDown"
                        size={FontSizes[2]}
                    />
                }
            >
                <Box display="flex" alignItems="center">
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {t('GlobalAdmin.Tenant.Edit.AddAdmin.title')}
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container>
                    <Grid item xs={12} mb="24px">
                        <FormLabel>
                            {t('GlobalAdmin.Tenant.Edit.AddAdmin.adminEmail')}
                        </FormLabel>
                        <TextField
                            onChange={(e) => setAdminEmail(e.target.value)}
                            value={adminEmail || ''}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <hr />
                    </Grid>

                    <Button
                        data-trackid="globalAdmin_tenant_addAdminUser"
                        onClick={() =>
                            saveAdminUser(adminEmail, tenant.id, onSuccessFn, t)
                        }
                        color="primary"
                        variant="contained"
                    >
                        {t('GlobalAdmin.Tenant.Edit.AddAdmin.button')}
                    </Button>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};
